import { FacilityDetailsHeaderQueryResponse } from "../queries";
import IconButton from "@/components/IconButton";
import { gql, useMutation } from "@apollo/client";
import { showSnackbar } from "@/lib/snackbarUtils";
import { DOMAIN, PERMISSION, useHasCapabilityBool } from "@/hooks/useCapabilities";

const UNARCHIVE_FACILITY_MUTATION = gql`
  mutation UnarchiveFacility($id: ID!) {
    unarchiveFacility(id: $id) {
      success
      message
      facility {
        id
        archivedAt
      }
    }
  }
`;

const ArchiveFacilityButton = ({ facility }: { facility: FacilityDetailsHeaderQueryResponse["facility"] }) => {
  const [unarchiveFacility, { loading }] = useMutation(UNARCHIVE_FACILITY_MUTATION, {
    onCompleted: (data) => {
      if (data.unarchiveFacility.success) {
        showSnackbar(data.unarchiveFacility.message, { close: true });
      } else {
        showSnackbar(data.unarchiveFacility.message);
      }
      close();
    },
    onError: (error) => {
      showSnackbar(`An unexpected error occurred: ${error.message}`);
    }
  });

  const canUnarchive = useHasCapabilityBool({ domain: DOMAIN.FACILITIES, permission: PERMISSION.manageFacilities });
  if (!canUnarchive) return null;

  if (facility.archivedAt == null) return null;

  return (
    <div className="hidden">
      <IconButton
        name="unarchive"
        onClick={() => unarchiveFacility({ variables: { id: facility.id } })}
        disabled={loading}
        data-testid="unarchive-facility-button"
      />
    </div>
  );
};

export default ArchiveFacilityButton;
